export function copyToClipboard(value: string): void {
  if (navigator && navigator.clipboard) {
    navigator.clipboard.writeText(value);
  } else {
    let textarea: any = document.createElement('textarea');
    textarea.value = value;
    textarea.select();
    document.execCommand('copy');
    textarea = null;
  }
}
